import { Localizable } from '@components/localizable/Localizable'
import { Program } from '@models/membership/Program'
import { selectSelectedComplementaryItem } from '@store/balance/ComplementaryItemReducer'
import { useAppSelector } from '@store/hooks'
import { SBAsyncSelect } from '@supplement-bacon/react-async-select'
import { ColorPicker } from '@supplement-bacon/react-toolkit/components'
import { SBRMFormActionProps } from '@supplement-bacon/sbrm-react'
import { Entity } from '@utils/Entities'
import { requiredRule } from '@utils/rules'
import { Form, Input } from 'antd'
import { useEffect } from 'react'
import SBIonIcon from '../SBIonIcon'

const Update = ({ form, formProps }: SBRMFormActionProps) => {
  const item = useAppSelector(selectSelectedComplementaryItem())

  useEffect(() => {
    if (item) {
      form.setFieldsValue(item)
    }
  }, [item])

  if (item === undefined) {
    return <></>
  }

  return (
    <Form {...formProps} form={form} layout="vertical">
      <Form.Item name="id" hidden style={{ display: 'none' }} rules={[]}>
        <Input type="hidden" />
      </Form.Item>

      <Localizable.Input name="name" label="Name" rules={[requiredRule()]} />

      <Form.Item name="icon" label="Icon">
        <SBIonIcon.Picker />
      </Form.Item>

      <Form.Item name="color" label="Color">
        <ColorPicker />
      </Form.Item>

      <Form.Item name="programs" label={'Programs'} rules={[requiredRule()]}>
        <SBAsyncSelect<Program>
          entity={Entity.membershipProgram}
          multiple
          allowClear
        />
      </Form.Item>
    </Form>
  )
}

export default Update
